export const textColors = {
  'brand-intense': '#2E43BD',
  'brand-moderate': '#3C52D8',
  'brand-quiet': '#8181FF',
  'neutral-intense': '#000F44',
  'neutral-moderate': '#1F2C5A',
  'neutral-quiet': '#576183',
  'neutral-supershy': '#959CB1',
  'danger-intense': '#921E1E',
  'danger-moderate': '#B83F3F',
  'danger-quiet': '#DF6262',
  'warning-intense': '#774812',
  'warning-moderate': '#B36E20',
  'warning-quiet': '#E59D4B',
  'positive-intense': '#1D5543',
  'positive-moderate': '#2E715C',
  'positive-quiet': '#41AB8A',
  'reverse-intense': '#FFFFFF',
  'reverse-moderate': '#E1E4EB',
  'reverse-quiet': '#AEB6CA',
  'reverse-supershy': '#737B98',
};

export const backgroundColors = {
  'brand-intense': '#576BE1',
  'brand-moderate': '#DFE6FD',
  'brand-quiet': '#F2F5FB',
  'neutral-intense': '#000F44',
  'neutral-moderate': '#CCD1DE',
  'neutral-quiet': '#E8EAF0',
  'neutral-supershy': '#F5F6F8',
  'neutral-white': '#FFFFFF',
  'danger-intense': '#B61313',
  'danger-moderate': '#FAC5C5',
  'danger-quiet': '#FDE5E5',
  'warning-intense': '#A96416',
  'warning-moderate': '#F4D4B0',
  'warning-quiet': '#F9E9D7',
  'positive-intense': '#0A7A56',
  'positive-moderate': '#B7E5D6',
  'positive-quiet': '#E2F5EF',
  'reverse-intense': '#D9DBE3',
  'reverse-moderate': '#666F8F',
  'reverse-quiet': '#333F69',
};

export const borderColors = {
  'brand-intense': '#576BE1',
  'brand-moderate': '#BCC4F3',
  'brand-quiet': '#DDE1F9',
  'neutral-intense': '#142F6E',
  'neutral-moderate': '#ADB6CC',
  'neutral-quiet': '#DCE0E9',
  'danger-intense': '#D73B3B',
  'danger-moderate': '#E99797',
  'danger-quiet': '#F79E9E',
  'warning-intense': '#DB9446',
  'warning-moderate': '#E9BA86',
  'warning-quiet': '#FCEAD6',
  'positive-intense': '#3AB08B',
  'positive-moderate': '#86D3BB',
  'positive-quiet': '#D5F0E7',
  'reverse-moderate': '#CFD2DB',
  'reverse-quiet': '#4D577C',
};
